// Added by Sejune Oh on 2019-05-09
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Logger from './Logger'
import { getCookie } from './util'
import Intl from './Intl'
import { HTTP_HEADER_AUTH_KEY, AUTH_TOKEN_COOKIE, HTTP_HEADER_IGNORE_INTERCEPTOR, HVN_INTEGRATED } from './define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { TokenValidStatusProps } from '../stores/user/UserAuth'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default function (axios: any, rootStore: any) {
  Logger.networkLog('(Axios) Interceptor binded')

  // Init
  axios.defaults.headers.common[HTTP_HEADER_IGNORE_INTERCEPTOR] = ''

  axios.interceptors.request.use(async (config: any) => {
    if (config.headers.common[HTTP_HEADER_IGNORE_INTERCEPTOR] === 'true') return config

    if (rootStore.userAuth!.isSignedUp) {
      const status = rootStore.userAuth!.checkTokenValidStatus({
        access_token_exp: rootStore.userAuth!.userInfo!.access_token_exp as number,
        refresh_token_exp: rootStore.userAuth!.userInfo!.refresh_token_exp as number,
      })

      switch (status) {
        case TokenValidStatusProps.REFRESH_TOKEN_EXPIRED:
          // prettier-ignore
          const title = Intl.getIntlText({ id: 'htmljs_react.global.axiosinterceptor.dialog_title_session_expired' })
          // prettier-ignore
          const description = Intl.getIntlText({ id: 'htmljs_react.global.axiosinterceptor.dialog_desc_session_expired' })
          const confirmBtn = Intl.getIntlText({ id: 'htmljs_react.global.axiosinterceptor.dialog_btn_confirm' })

          Logger.networkLog('[Axios Interceptor] Token Status : REFRESH-TOKEN-EXPIRED -> Sign out')

          // To integrate with the havana project
          if (localStorage.getItem(HVN_INTEGRATED)) {
            window.top?.postMessage('aview.expired_referesh_token', '*')
          }

          if (rootStore.userAuth!.isSignedUp) await rootStore.userAuth!.signOut()

          if (!rootStore.globalEvt!.isScreenLockActive) {
            rootStore.globalEvt!.openDialog(
              {
                disableBackdropClick: true,
                title,
                description,
                confirmBtn,
                hideCancelBtn: true,
              },
              () => { }
            )
          }
          return false
        case TokenValidStatusProps.ACCESS_TOKEN_EXPIRED:
          Logger.networkLog('[Axios Interceptor] Token Status : ACCESS-TOKEN-EXPIRED -> Refresh token')
          await rootStore.userAuth!.refreshAccessToken(getCookie(AUTH_TOKEN_COOKIE))
          config.headers.common[HTTP_HEADER_AUTH_KEY] = axios.defaults.headers.common[HTTP_HEADER_AUTH_KEY]
          break
        // case TokenValidStatusProps.VALID:
        //     Logger.networkLog('[Axios Interceptor] Token Status : VALID')
      }
    }

    return config
  }, null)
}
